var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fades" } }, [
    _vm.show
      ? _c(
          "div",
          {
            staticClass: "proctorSQDialog",
            staticStyle: { "z-index": "2001" },
            attrs: { id: "proctorSQDialog" }
          },
          [
            _c(
              "div",
              {
                staticClass: "dialogBox",
                class: { remaidBox: _vm.code && _vm.text.length > 200 }
              },
              [
                _c("div", { staticClass: "title bold" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _vm.text
                  ? _c(
                      "div",
                      {
                        staticClass: "text",
                        class: { remaid: _vm.code && _vm.text.length > 200 }
                      },
                      [_vm._v(_vm._s(_vm.text))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.img
                  ? _c("div", { staticClass: "img" }, [
                      _c("img", {
                        attrs: { src: _vm.img, alt: "", srcset: "" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.yesTxt
                  ? _c("div", { staticClass: "btn" }, [
                      _c(
                        "div",
                        { staticClass: "primary", on: { click: _vm.yesBtn } },
                        [_vm._v(_vm._s(_vm.yesTxt))]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-a81a4fc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a81a4fc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/proctorSQDialog/src/main.vue
// module id = null
// module chunks = 